var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { SubjectLabel } from '@/models/SubjectLabel';
let AddSubjectLabelDialog = class AddSubjectLabelDialog extends Vue {
    constructor() {
        super(...arguments);
        this.subjectLabel = new SubjectLabel();
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    create() {
        this.subjectLabel.create().then((subjectLabel) => {
            this.$emit('subjectLabelCreated');
            this.$emit('input', false);
        });
        this.clear();
    }
    clear() {
        this.subjectLabel = new SubjectLabel();
    }
};
AddSubjectLabelDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddSubjectLabelDialog);
export default AddSubjectLabelDialog;
